// TODO: usar nuevo contexto en todo el proyecto
/**
 * Ahora que hemos hecho el nuevo "endpoint" (el viejo si le envías el nuevo campo products)
 */

// import { createContext, useState, useContext, useCallback } from 'react';
import { message } from 'antd';
// import { useI18n } from './i18n';
// import { isBlank } from 'utils/StringUtils';
import { COOKIES, getMarket } from 'utils/helpers';
// import { IS_CAMPER, IS_NNORMAL } from 'utils/constants';
import { addToBag, getCrossSelling } from 'actions/products';
// import { dataLayerCartClick, dataLayerHandleEvent } from 'utils/dataLayers';
// import { parseBagItemsEcommerceGA4 } from 'utils/gtmUtils';
import { prepareBagPayload, setBagCookies } from 'utils/bag';
import { setCookie } from 'utils/helpers';

// const BagContext = createContext(undefined);

// const retrieveBagHandler = async ({ locale }, callback = () => {}) => {
//   try {
//     const market = getMarket(locale);
//     const bagHash = getCookie(COOKIES.BAG);
//     const autoVoucher = getCookie(COOKIES.AUTO_BONDS) || '';
//     const voucher = getCookie(COOKIES.BONDS) || '';
//     const voucherDiscount = IS_CAMPER && autoVoucher && autoVoucher === AUTO_BONDS.APPLY;
//     const cookiesMarket = getCookie(COOKIES.BAG_MARKET);

//     if (!bagHash) {
//       throw {
//         error: false,
//         message: 'Bag hash not found',
//       };
//     }

//     if (cookiesMarket !== market) {
//       eraseCookie(COOKIES.BAG);
//       eraseCookie(COOKIES.BAG_DATE);
//       eraseCookie(COOKIES.BAG_MARKET);
//       eraseCookie(COOKIES.SHIPMENT);
//       eraseCookie(COOKIES.EMPLOYEE_ID);
//       eraseCookie(COOKIES.PACKSTATION);
//       eraseCookie(COOKIES.IS_CTR);
//       eraseCookie(COOKIES.ZIP);

//       throw {
//         error: true,
//         message: 'Market not match',
//       };
//     }

//     const payload = {
//       hashOrderId: bagHash,
//       profile: locale,
//     };

//     if (voucherDiscount || (IS_NNORMAL && !isBlank(voucher))) {
//       payload.voucher = voucher;
//     }

//     const result = await retrieveBag({ payload });

//     dataLayerHandleEvent({
//       event: 'cart_sync',
//       cart: {
//         items: parseBagItemsEcommerceGA4(result.shoppingCart),
//       },
//     });

//     return callback(result);
//   } catch (e) {
//     if (e.error === true) {
//       return callback(null);
//     } else {
//       console.error('Init bag error', e);
//     }
//     return callback(null);
//   }
// };

// export function BagProvider({ children }) {
//   const { locale } = useI18n();
//   // Context
//   const {
//     t,
//     profileData: { config },
//   } = useI18n();

//   // State
//   const [data, setBagData] = useState(undefined); // bag is undefined until it's loaded. After that the value is either the bag object or null if empty.
//   const [recommendedProductsForBag, setRecommendedProductsForBag] = useLocalStorage('bag-recommended', []);

//   const bag = data?.shoppingCart ?? [];

//   // Derived state
//   const bagLength = bag.length ?? 0;
//   const disabledProducts = !isBlank(data.blockedSkus) ? data.blockedSkus : null;
//   const bagHasMembersOnlyProduct = bag.some((product) => product.membersOnly === true);
//   let promoLabel = null;
//   let promoLabelType = 'progress';

//   if (!!config?.show_free_shipping) {
//     promoLabel = data?.freeShippingLabel || null;
//   }
//   if (!!config?.show_gift_purchase) {
//     promoLabel = data?.gwplabel || data?.gwplabelObtained || data?.freeShippingLabel || null;
//     if (data?.gwplabelObtained && data?.gwplabelObtained !== '') {
//       promoLabelType = 'obtained';
//     }
//   }

//   const handleRetrieveBag = useCallback(async () => {
//     await retrieveBagHandler(
//       {
//         locale,
//       },
//       (result) => {
//         if (result === null) {
//           setBagData(null);
//           setRecommendedProductsForBag([]);
//         }
//         if (result) {
//           setBagData(result.shoppingCart);
//         }
//       },
//     );
//     // en realidad el setRecommendedProductsForBag no sebe de añadir al array de dependencias.
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     handleRetrieveBag();
//   }, []);

//   const handleAddToBag = async ({ mainId, payload, redirect = false, allMandatory = true, checkStock = false }) => {
//     // Si nos llega products en el payload lo usamos
//     let products = payload.products ?? [{ id: mainId }];
//     // primero checkeamos si el producto que queremos comprar esta bloqueado
//     if (products.some((product) => disabledProducts.includes(product.id))) {
//       // si todos los productos son necesarios y uno de ellos esta bloqueado, no se puede procesar el pedido. Si solo hay un producto y esta bloqueado no se puede procesar el pedido
//       if (allMandatory || products.length === 1) {
//         // FIXME: etiquetas para errores en bolsa
//         message.error('No se puede procesar el pedido en este momento');
//         throw {
//           client: true,
//           message: 'Cannot add blocked product to bag',
//         };
//       }
//       // si no todos son obligatorios y uno de ellos esta bloqueado, lo eliminamos del array de productos
//       products = products.filter((product) => !disabledProducts.includes(product.id));
//     }

//     // Checkear si superamos el limite de productos en la bolsa
//     if (bagLength + products.length > MAX_BAG_LENGTH) {
//       // si todos los productos son necesarios bloqueamos el pedido, o ya hemos llegado al límite de productos en la bolsa bloqueamos la llamada.
//       if (allMandatory || bagLength >= MAX_BAG_LENGTH) {
//         // FIXME: etiquetas para errores en bolsa
//         message.error('No se puede procesar el pedido en este momento');
//         throw {
//           client: true,
//           message: 'Cannot add more products to bag',
//         };
//       }
//       // Si podemos meter al menos 1 producto en la bolsa, intentamos añadirlo
//     }
//     const completePayload = prepareBagPayload({ locale, basePayload: payload, allMandatory, checkStock });
//     try {
//       const [bagResult, crossSellingProducts] = await Promise.allSettled([addToBag(completePayload), getCrossSelling(null, locale, mainId)]);

//       if (bagResult.status === 'rejected') {
//         throw {
//           error: false,
//           bagResult,
//         };
//       }

//       if (!result.hashOrderId) {
//         throw {
//           error: false,
//           message: 'Bag hash not found',
//         };
//       }
//       const result = bagResult.value;
//       dataLayerCartClick({ ...productSheet, productSheet }, result, false, bag);
//       setBagCookies({ hash: encodeURI(result.hashOrderId), market });
//       const { sapActive, extendedBlockSAP, shoppingCart } = result;

//       if (!sapActive && !extendedBlockSAP) {
//         // can't pay
//         window.location.assign(`${window.location.origin}/${locale}/pedido_offline`);
//         return;
//       }

//       if (extendedBlockSAP) {
//         // can pay
//         setCookie(COOKIES.SHIPMENT, '01', undefined, COOKIES.DOMAIN);
//       }
//       if (redirect) {
//         window.location.assign(`${window.location.origin}/${locale}/bolsa`);
//         return;
//       }
//       setBagData(shoppingCart);
//       setRecommendedProductsForBag((prev) => [...crossSellingProducts, ...prev].map((item, i) => ({ ...item, order: i })));
//       return result;
//     } catch (error) {
//       console.error('Error adding to bag', error);
//       message.error('No se puede procesar el pedido en este momento');
//       throw null;
//     }
//   };

//   return (
//     <BagContext.Provider
//       value={{
//         bag,
//         bagLength,
//         recommendedProductsForBag,
//         disabledProducts,
//         bagHasMembersOnlyProduct,
//         promoLabel,
//         promoLabelType,
//         handleAddToBag,
//         handleRetrieveBag,
//       }}
//     >
//       {children}
//     </BagContext.Provider>
//   );
// }

// export function useBag() {
//   const context = useContext(BagContext);
//   if (context === undefined) {
//     throw new Error('useBag must be used within a BagProvider');
//   }
//   return context;
// }

type AddToBagProps = {
  locale: string;
  mainId: string;
  payload: any;
  redirect?: boolean;
  allMandatory?: boolean;
  checkStock?: boolean;
};

export const handleAddToBag = async ({ mainId, payload, redirect = false, allMandatory = true, checkStock = false, locale }: AddToBagProps) => {
  // Si nos llega products en el payload lo usamos
  // let products = payload.products ?? [{ id: mainId }];
  // primero checkeamos si el producto que queremos comprar esta bloqueado
  // if (products.some((product) => disabledProducts.includes(product.id))) {
  // si todos los productos son necesarios y uno de ellos esta bloqueado, no se puede procesar el pedido. Si solo hay un producto y esta bloqueado no se puede procesar el pedido
  // if (allMandatory || products.length === 1) {
  //   // FIXME: etiquetas para errores en bolsa
  //   message.error('No se puede procesar el pedido en este momento');
  //   throw {
  //     client: true,
  //     message: 'Cannot add blocked product to bag',
  //   };
  //   // }
  //   // si no todos son obligatorios y uno de ellos esta bloqueado, lo eliminamos del array de productos
  //   // products = products.filter((product) => !disabledProducts.includes(product.id));
  // }

  // Checkear si superamos el limite de productos en la bolsa
  // if (bagLength + products.length > MAX_BAG_LENGTH) {
  //   // si todos los productos son necesarios bloqueamos el pedido, o ya hemos llegado al límite de productos en la bolsa bloqueamos la llamada.
  //   if (allMandatory || bagLength >= MAX_BAG_LENGTH) {
  //     // FIXME: etiquetas para errores en bolsa
  //     message.error('No se puede procesar el pedido en este momento');
  //     throw {
  //       client: true,
  //       message: 'Cannot add more products to bag',
  //     };
  //   }
  //   // Si podemos meter al menos 1 producto en la bolsa, intentamos añadirlo
  // }
  const completePayload = prepareBagPayload({ locale, basePayload: payload, allMandatory, checkStock });
  try {
    const [bagResult, crossSellingProducts] = await Promise.allSettled([addToBag(completePayload), getCrossSelling({ profile: locale, productId: mainId })]);

    if (bagResult.status === 'rejected') {
      throw {
        error: false,
        bagResult,
      };
    }
    const result = bagResult.value;

    if (!result.hashOrderId) {
      throw {
        error: false,
        message: 'Bag hash not found',
      };
    }
    // dataLayerCartClick({ ...productSheet, productSheet }, result, false, bag);
    setBagCookies({ hash: encodeURI(result.hashOrderId), market: getMarket(locale) });
    const { sapActive, extendedBlockSAP, shoppingCart } = result;

    if (!sapActive && !extendedBlockSAP) {
      // can't pay
      window.location.assign(`${window.location.origin}/${locale}/pedido_offline`);
      return;
    }

    if (extendedBlockSAP) {
      // can pay
      setCookie(COOKIES.SHIPMENT, '01', undefined, COOKIES.DOMAIN);
    }
    if (redirect) {
      window.location.assign(`${window.location.origin}/${locale}/bolsa`);
      return;
    }
    // Empieza el cambio
    // setBagData(shoppingCart);
    // setRecommendedProductsForBag((prev) => [...crossSellingProducts, ...prev].map((item, i) => ({ ...item, order: i })));
    // Acaba el cambio.Quitar lo siguiente cuando se use el nuevo contexto
    return {
      cartResult: result,
      crossResult: crossSellingProducts.status === 'fulfilled' ? crossSellingProducts.value : [],
    };
    // return result;
  } catch (error) {
    console.error('Error adding to bag', error);
    message.error('No se puede procesar el pedido en este momento');
    throw null;
  }
};
